// extracted by mini-css-extract-plugin
module.exports = {"container":"attribution_container__xpdT_","attribution-in":"attribution_attribution-in__CONBZ","avatar":"attribution_avatar__DJdGG","logo":"attribution_logo__eqINV"};